import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Header from '../../Components/HeaderMain';
import Spinner from '../../Components/Spinner';
import { useMain } from '../../Hook/Main';
import Layout from '../../Layout'
function Result() {
    const { code } = useParams();
    const [loading, setloading] = useState(true)
    const [result, setresult] = useState()
    const { Request } = useMain();
    const nav = useNavigate();
    useEffect(() => {
        Request({
            url: '/result-reqpay',
            props: {
                id: code
            },
            callback: (res) => {
                setloading(false)
                if (res) {
                    setresult(res)
                }
            }
        })
    }, [])

    if (loading) {
        return null;
    }
    if (!result) {
        return null;
    }
    return (
        <Layout>
            <Header lable="نتیجه پرداخت" back={() => nav('/')} />
            <div className={`text-center pt-5 mt-5 text-${result.error ? "danger" : "success"}`}>
                {result.error ? result.error : "تراکنش با موفقیت انجام شد"}
            </div>
            <div className='result-payment'>
                <ul>
                    <li>
                        <span>نام طرح</span>
                        <span>{result.plan}</span>
                    </li>
                    <li>
                        <span>آگهی</span>
                        <span>{result.item}</span>
                    </li>
                    <li>
                        <span>مبلغ</span>
                        <span>{parseInt(result.price).toLocaleString()} تومان</span>
                    </li>
                    <li>
                        <span>کد پیگیری</span>
                        <span>{result.code}</span>
                    </li>
                </ul>
            </div>
        </Layout>
    )
}

export default Result